import { Popover, Select } from 'antd';
import {
  countryCode2ChineseNameMap,
  countryCode2EnglishNameMap,
} from 'src/constants/country';
import CountryTree from './CountryTree';
import cls from 'classnames';
import styles from './CountryInput.module.scss';

interface Props {
  value?: string[];
  onChange?(value: string[]): void;
  isEn: boolean;
  isError?: boolean;
}

const CountryInput: React.FC<Props> = ({ isEn, isError, ...props }) => {
  const selectOptions = Object.keys(countryCode2ChineseNameMap).map((code) => ({
    label: isEn
      ? countryCode2EnglishNameMap[code]
      : countryCode2ChineseNameMap[code],
    value: code,
  }));
  return (
    <Popover
      content={<CountryTree isEn={isEn} {...props} />}
      trigger="click"
      placement="bottom"
      getPopupContainer={(triggerNode: HTMLElement | null) => {
        return triggerNode.parentElement || document.body;
      }}
      overlayClassName={styles.popover}
      style={{ width: '100%' }}
    >
      <Select
        mode="multiple"
        options={selectOptions}
        open={false}
        showSearch={false}
        maxTagCount="responsive"
        maxTagPlaceholder={(v) => `+${v.length}`}
        placeholder={isEn ? 'Please select' : '请选择'}
        allowClear
        className={cls(styles.select, {
          [styles.selectError]: isError,
        })}
        {...props}
      />
    </Popover>
  );
};

export default CountryInput;
